export default __webpack_public_path__ + "static/ipad-d9c10e6df68d20d97de52e58bb1e1e8e.png";